import { useCallback } from 'react';
import useLog from '../useLog';
import { ReportsData, ReportsIndexData } from 'types/flowPatrol';
import { AdminContentCategory } from 'types';

const useReports = () => {
  const { fetchAPIWithLog } = useLog('Reports');

  const getReportsIndex = useCallback(
    async (
      category: AdminContentCategory,
      page: number,
      perPage: number,
      selectedMonth: number,
      selectedYear: number,
    ): Promise<ReportsIndexData> => {
      return (await fetchAPIWithLog(
        `${category}?page=${page}&perPage=${perPage}&month=${selectedMonth}&year=${selectedYear}`,
      )) as ReportsIndexData;
    },
    [fetchAPIWithLog],
  );

  const getReportsWithId = useCallback(
    async (
      id: string,
      category: AdminContentCategory,
    ): Promise<{
      data: ReportsData;
      status: string;
      error?: string | null;
    }> => {
      return (await fetchAPIWithLog(`${category}/id?id=${id}`)) as {
        data: ReportsData;
        status: string;
        error?: string | null;
      };
    },
    [fetchAPIWithLog],
  );

  return {
    getReportsIndex,
    getReportsWithId,
  };
};

export default useReports;
